<template>
    <b-modal ref="mdlRsaSpecializzazionePai" :title="title" centered no-close-on-backdrop no-close-on-esc hide-header-close size="lg">
        <b-row>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <label class="sa-label-data">Ruolo</label>
                <b-form-select :options="ruoliOptions" value-field="id" text-field="ruolo" :value="''" v-model="jsonDataSpecializzazionePai.idRuolo">
                    <template #first>
                        <b-form-select-option :value="''" disabled> - Seleziona Ruolo - </b-form-select-option>
                    </template>
                </b-form-select>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <label class="sa-label-data">Specializzazione</label>
                <b-form-input v-model="jsonDataSpecializzazionePai.specializzazione"></b-form-input>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <label class="sa-label-data">Note</label>
                <b-form-textarea v-model="jsonDataSpecializzazionePai.note" max-rows="10" rows="7"> </b-form-textarea>
            </b-col>
        </b-row>
        <template #modal-footer>
            <b-button size="md" variant="outline-danger" @click="onCloseSpecializzazionePaiModal">Annulla</b-button>
            <b-button size="md" variant="outline-success" @click="onSaveSpecializzazionePai">Salva</b-button>
        </template>
        <modal-error ref="cmpModalError"></modal-error>
    </b-modal>
</template>
<script>
import UtilityMixin from "../../../utility/UtilityMixin";
import ModalError from "../../../../template/components/modal/components/ModalError.vue";
export default {
    mixins: [UtilityMixin],
    mounted() {
        let me = this;
        me.loadRuoliPaiData();
    },
    components: { ModalError },
    data() {
        return {
            pathResourcePaiSpecializzazione: "/rsapairuolospecializzazione",
            pathResourcePaiRuoli: "/rsapairuoli",
            title: null,
            ruoliOptions: [],
            jsonDataSpecializzazionePai: {
                id: null,
                specializzazione: null,
                idRuolo: "",
                note: null,
            },
        };
    },
    methods: {
        /* nuovaSpecializzazionePai() {
            let me = this;
            me.isNew = true;
            me.jsonDataSpecializzazionePai = {
                specializzazione: null,
                ruolo: null,
                idRuolo: "",
                note: null,
            };
            me.$refs.mdlRsaSpecializzazionePai.show();
        },

        editSpecializzazionePai(item) {
            let me = this;
            me.isNew = false;
            me.jsonDataSpecializzazionePai = { ...item };
            me.loadRuoliPaiData();
            me.$refs.mdlRsaSpecializzazionePai.show();
        }, */

        show(jsonData) {
            let me = this;
            me.jsonDataSpecializzazionePai = jsonData;
            me.title = !jsonData.id ? "Nuova Specializzazione" : "Aggiorna Specializzazione";
            me.loadRuoliPaiData();
            /* console.log("ITEM", jsonData); */
            /* console.log(this.jsonDataSpecializzazionePai); */

            me.$refs.mdlRsaSpecializzazionePai.show();
        },
        loadRuoliPaiData() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourcePaiRuoli, null, me.loadRuoliPaiDataSuccess, me.loadRuoliPaiDataError);
        },

        loadRuoliPaiDataSuccess(response) {
            let me = this;
            me.ruoliOptions = response.data.data.list;
        },
        loadRuoliPaiDataError(error) {
            console.log("Errore durante il caricamento di loadRuoliPaiDataError :", error);
        },
        onCloseSpecializzazionePaiModal() {
            let me = this;
            me.jsonDataSpecializzazionePai = {};
            me.$emit("onCloseSpecializzazionePaiModal");
            me.$refs.mdlRsaSpecializzazionePai.hide();
        },
        onSaveSpecializzazionePai() {
            let me = this;
            UtilityMixin.methods.saveResource(me.pathResourcePaiSpecializzazione, me.jsonDataSpecializzazionePai, me.saveSpecializzazionePaiSuccessResponse, me.saveSpecializzazionePaiErrorResponse);
        },
        saveSpecializzazionePaiSuccessResponse(response) {
            let me = this;
            me.$emit("saveSpecializzazionePai", response);
            me.$refs.mdlRsaSpecializzazionePai.hide();
            me.$bvToast.toast("Salvataggio avvvenuto con successo", {
                title: "Success",
                variant: "success",
                solid: true,
            });
        },
        saveSpecializzazionePaiErrorResponse(error) {
            let me = this;
            me.$refs.cmpModalError.show(error.response.data.messaggio);
        },
        deleteSpecializzazionePai(id) {
            let me = this;
            UtilityMixin.methods.deleteResource(me.pathResourcePaiSpecializzazione + "/" + id, null, me.deleteSpecializzazionePaiSuccess, me.deleteSpecializzazionePaiError);
        },

        deleteSpecializzazionePaiSuccess(response) {
            let me = this;
            me.$emit("deleteSpecializzazionePai", response);
            me.$bvToast.toast("Eliminazione avvenuta con successo", {
                title: "Successo",
                variant: "success",
                solid: true,
            });
        },
        deleteSpecializzazionePaiError(response) {
            let me = this;
            me.$emit("deleteSpecializzazionePai", response);
            me.$bvToast.toast("Errore durante la cancellazione", {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },
        onDeleteSpecializzazionePai(item) {
            let me = this;
            me.$bvModal
                .msgBoxConfirm("Sei sicuro di eliminare questa specializzazione?", {
                    title: "Eliminazione Specializzazione PAI",
                    buttonSize: "sm",
                    okTitle: "SI",
                    cancelTitle: "NO",
                    okVariant: "danger",
                    cancelVariant: "secondary",
                    hideHeaderClose: true,
                    footerClass: "p-2",
                    centered: true,
                })
                .then((value) => {
                    if (value) {
                        me.deleteSpecializzazionePai(item.id);
                    }
                })
                .catch((e) => {
                    console.log(e);
                });
        },
    },
};
</script>
